export default "__VITE_ASSET__kYWWNLMV__"